app.service("CurrencyService", ['$rootScope', function ($rootScope) {

    const service = this;

    const CurrencyModel = function () {
        this.currencies = {};
        this.default_currency = {
            display_rate: 1,
            html_symbol: "&pound;",
            id: "GBP",
            symbol: "£",
            type: "currency",
            _acc_id: "ST",
            _acc_rate: 1
        }
    };

    this.model = new CurrencyModel();
    const model = this.model;


    this.requireCurrency = function (currencyID, callback) {
        currencyID = currencyID ? currencyID : $rootScope.model.account.customer_data ? $rootScope.model.account.customer_data.currency : null;

        if (!currencyID) {
            if (callback) {
                callback(false);
            }
            return;
        }
        const currency = cloneCurrency(currencyID);
        if (currency) {
            if (callback) {
                callback(true, currency, []);
            }
            return;
        }

        const endpoint = '/request/api.php/currencies/' + currencyID;

        $rootScope.service.request.getRequest(endpoint, function (success, currency, messages) {
            if (success) {
                model.currencies[currencyID] = currency;
            }
            currency = cloneCurrency(currencyID);
            callback(success, currency, messages);
        })
    }

    function cloneCurrency(currencyID) {
        return model.currencies[currencyID] ? JSON.parse(JSON.stringify(model.currencies[currencyID])) : null;
    }

    this.currencyData = function () {
        const customerData = $rootScope.model.account.customer_data;
        if (!customerData) {
            return model.default_currency;
        }
        if (!customerData.currencyData) {
            return model.default_currency;
        }
        return customerData.currencyData;
    }

    this.currencySymbol = function (currencyID) {
        if (currencyID) {
            if (currencyID.toUpperCase() === "GBP") {
                return "£"
            }
            if (currencyID.toUpperCase() === "EUR") {
                return "€"
            }
        }
        return service.currencyData().symbol;
    }

    this.currencyDisplayRate = function () {
        const customerData = $rootScope.model.account.customer_data;
        if (!customerData) {
            return 1;
        }
        if (!customerData.currencyData) {
            return 1;
        }
        return customerData.currencyData.display_rate;
    }

    this.currencyFormat = function (priceFloat, emptyIfZero) {
        priceFloat = priceFloat ? priceFloat : 0;
        if (emptyIfZero && priceFloat === 0) {
            return "";
        }
        return service.currencySymbol() + priceFloat.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    this.currencyPrice = function (sterlingPrice) {
        return sterlingPrice * service.currencyDisplayRate();
    }

    this.currencyFormatDisplayPrice = function (priceFloat, emptyIfZero) {
        return service.currencyFormat(service.currencyPrice(priceFloat), emptyIfZero);
    }
}]);